import {Component, Injector, OnInit} from '@angular/core';
import {UserService} from "../../services/user/user.service";
import {BaseComponent} from "../base/base.component";
import Swal from "sweetalert2";

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent extends BaseComponent implements OnInit{

  oldPassword: string = '';
  newPassword: string = '';
  confirmPassword: string = '';


  constructor(public userService: UserService, public serviceInjector: Injector) {
    super(serviceInjector);
  }


  ngOnInit(): void {

  }

  passwordMatch() {
    return this.newPassword === this.confirmPassword;
  }

  async resetPasswordHandler(){

    if ( this.oldPassword.trim().length === 0 || this.newPassword.trim().length === 0 || this.confirmPassword.trim().length === 0 ) return;

    this.spinner.show();

    const user = await this.userService.getCurrentUser();

    if (!user.success) return;

    const userId = user.data.id;

    const resetPassword = await this.userService.updatePassword(this.newPassword, userId)

    this.spinner.hide();

    if ( resetPassword ) {
      Swal.fire({
        icon: 'success',
        title: 'Password aggiornata con successo'
      });
    } else {
      Swal.fire({
        icon: 'error',
        title: "Errore durante l'aggiornamento della password"
      });
    }

    this.previousPage()
  }

}
